import React, { Component } from "react";
import { connect } from "react-redux";
import {
  verify2FAOtp,
  send2FAOtp,
  resetState,
} from "../../actions/authActions";

import { Form, Col, Row, Button, Alert } from "react-bootstrap";
import { Redirect } from "react-router";
import { withRouter } from "react-router-dom";
// import Moment from 'react-moment';
// import { getConsoleUserByNameOrNumber } from '../../actions/userLogActions';
// import Pagination from '../subLevel/Pagination';

import "../../assets/styles/RetailPortalCouponsList.css";
import { get, post, sess_get, sess_post } from "../../utils/HttpRequests";
import AddNumberCSVModal from "../modals/AddNumberCSVModal";

const REACT_APP_REDIRECT_AFTER =
  process.env.REACT_APP_REDIRECT_AFTER * 1000 || 10 * 1000;
const REACT_APP_RESEND_OTP_AFTER = process.env.REACT_APP_RESEND_OTP_AFTER || 30;
class TwoFaSendOtp extends Component {
  state = {
    otp: "",
    seconds: REACT_APP_RESEND_OTP_AFTER,
  };
  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  async componentDidMount() {
    if (!this.props.auth || !Object.keys(this.props.auth.user).length) {
      this.props.history.push("/");
    }
    if (this.props.auth && Object.keys(this.props.auth.user).length) {
      this.initiateTimer();
    }
  }
  verify2FAOtp = (e) => {
    e.preventDefault();
    const { user } = this.props.auth;
    const { phone_number } = user;
    if (phone_number) {
      this.props
        .verify2FAOtp(phone_number, this.state.otp)
        .then((res) => {
          setTimeout(() => {
            // this.props.history.push("/");
            this.props.resetState();
            this.props.history.push("/");
          }, REACT_APP_REDIRECT_AFTER);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  send2FAOtp = (e) => {
    e.preventDefault();

    let email = "";
    if (this.props.auth && this.props.auth.user) {
      email = this.props.auth.user.email;
      this.props
        .send2FAOtp(email)
        .then((res) => {
          this.props.history.push("/2fa-send-otp");
          this.initiateTimer();
        })
        .catch((err) => {
          this.props.setError('send otp error')
          console.log(err);
        });
    }
  };
  initiateTimer = () => {
    clearInterval(this.timer);
    this.setState({ seconds: REACT_APP_RESEND_OTP_AFTER });
    this.timer = setInterval(() => {
      if (this.state.seconds <= 0) {
        clearInterval(this.timer);
        this.setState({ seconds: "" });
        return;
      }
      this.setState({ seconds: this.state.seconds - 1 });
    }, 1000);
  };
  render() {
    const { seconds } = this.state;
    return (
      <Row>
        <Col sm={2}></Col>
        <Col sm={8} style={{ "padding-top": "10%" }}>
          <Form onSubmit={this.verify2FAOtp}>
            <Form.Group>
              <Form.Control
                type="text"
                onChange={this.onChange}
                value={this.state.otp}
                id="otp"
                placeholder="Enter otp sent to your registered mobile"
              />
            </Form.Group>
            <Form.Group>
              <Button type="submit">Submit</Button>
              <Button
                style={{ marginLeft: 10 }}
                onClick={this.send2FAOtp}
                disabled={seconds}
                type="submit"
              >
                Resend Otp{" "}
                {this.state.seconds ? `in ${this.state.seconds} seconds` : ""}
              </Button>
            </Form.Group>
            {this.props.error && (
              <Alert variant="success">{this.props.error}</Alert>
            )}
          </Form>
        </Col>
      </Row>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    error: state.auth.error,
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, {
  verify2FAOtp,
  send2FAOtp,
  resetState,
})(TwoFaSendOtp);
